import React from 'react';
import { Box, BoxProps, Divider, HeadingProps, Text } from '@chakra-ui/react';
import Heading from '#coreComponents/Heading';

const Header = ({ children, ...props }: BoxProps) => (
  <Box mb={4} {...props}>
    {children}
    <Divider pb={3} />
  </Box>
);

const Title = (props: HeadingProps) => <Heading as="h2" {...props} />;

const Description = (props: BoxProps) => (
  <Text color="gray.600" mt={2} {...props} />
);

const Card = ({ children, ...props }: BoxProps) => (
  <Box bg="white" p={4} boxShadow="base" borderRadius="md" {...props}>
    {children}
  </Box>
);

Card.Header = Header;
Card.Title = Title;
Card.Description = Description;

export default Card;
